@if(isLoadingFlights) {
<div class="h-full w-full p-4 flex flex-col justify-center items-center text-center">
    <div class="text-lg font-medium text-gray-600">Loading flights...</div>
</div>
} @else if(flights.length) {
<div class="
    h-full
    w-full p-4 sm:p-8 bg-white rounded-xl shadow flex-col justify-start items-end gap-4 flex overflow-hidden">
    <!--flight picker container header-->
    <div class="FlightpickerHeading self-stretch py-3 border-b border-zinc-100 justify-start items-center flex">
        <div class="VLjFlyg text-black text-2xl sm:text-4xl font-bold leading-9">{{
            'PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT'
            | transloco}}</div>
    </div>

    <pf-flight-picker (flightSelectedEvent)="selectFlight($event)" class="
    w-full
    h-full
    flex
    flex-col
    " type={{data.type}} [flights]="flights"></pf-flight-picker>
</div>
} @else {
<div class="h-full w-full p-4 flex flex-col justify-center items-center text-center">
    <div class="text-lg font-medium text-gray-600">
        Toggle hotel booking on, and choose your terminal.
    </div>
</div>
}